import { ChevronDown, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TableCell, TableRow } from "~/components/table";
import { Text } from "~/components/text";
import { cn } from "~/utils";
import type { BisacSubject } from "./bisac-subjects";

export const BisacCodesTableSubjectRow = ({
  subject,
  isOpen,
  onToggle,
}: {
  subject: BisacSubject;
  isOpen: boolean;
  onToggle: () => void;
}) => {
  const { t } = useTranslation("components");
  const Chevron = isOpen ? ChevronDown : ChevronRight;

  return (
    <TableRow
      className={cn("text-sm", isOpen && "bg-primary-25 hover:bg-primary-25")}
      onClick={onToggle}
      data-testid={`bisac-subject-${subject.prefix}`}
    >
      <TableCell className="py-2 pl-4">{subject.prefix}</TableCell>
      <TableCell className="py-2">
        <button
          type="button"
          aria-expanded={isOpen}
          className="flex items-center gap-2 text-left"
        >
          <span>{subject.heading}</span>
          <Text as="span" variant="subtle">
            {t("components:bisacCodesTable.codeCount", {
              count: subject.codes.length,
            })}
          </Text>
          <Chevron className="size-3 text-secondary-500" aria-hidden />
        </button>
      </TableCell>
      <TableCell />
    </TableRow>
  );
};
